import { WelcomeBeforeAfter } from "./components/BeforeAfter";
import { WelcomeBenefits } from "./components/Benefits";
import { WelcomeHeader } from "./components/Header";
import { WelcomeHowItWorks } from "./components/HowItWorks";
import { WelcomeNotificationChart } from "./components/NotificationChart";
import {
  WelcomeH2,
  WelcomeP,
  WelcomeSectionShell,
} from "./components/SectionShell";
import { WelcomeStatCards } from "./components/StatCards";

export default function Welcome() {
  return (
    <main className="w-full bg-[#f8f8f8] py-2">
      <div className="mx-auto w-full max-w-[1080px] px-2 sm:px-2">
        <div className="bg-transparent">
          <WelcomeHeader
            titleLines={[
              "Acompanhe como o Governo do",
              "Piauí se comunica com você",
            ]}
            description="Fique por dentro do que importa sem precisar buscar. O Governo do Piauí avisa você sobre serviços, prazos e atualizações diretamente no seu celular ou e-mail."
            notification={{
              appLabel: (
                <img
                  src="https://dev.pidigital.pi.gov.br/assets/img/logo/logo_solid.png"
                  alt="Gov.PI Cidadão"
                  className="h-11 w-11 rounded-xl"
                />
              ),
              title: "🎉 Feliz Aniversário! 🎉",
              timeLabel: "agora",
              body: "Hoje é o seu dia, e o Governo do Piauí celebra junto com você! Desejamos a você um novo ciclo repleto de coisas boas! Cont...",
            }}
          />

          <WelcomeSectionShell>
            <WelcomeH2>
              Veja quantas notificações o Gov.PI já enviou para o cidadão!
            </WelcomeH2>
            <WelcomeP>
              O Gov.pi Cidadão envia avisos importantes para você, sem precisar
              solicitar, de forma proativa.
            </WelcomeP>

            <WelcomeStatCards
              cards={[
                {
                  title: "31.856",
                  subtitle: "Notificações enviadas",
                  detail: "Dados de 2025 (até 25/02/2026)",
                },
                {
                  title: "Notificações Push",
                  subtitle: "Canal mais usado",
                  detail: "78% das notificações enviadas via push",
                },
                {
                  title: "Contracheque",
                  subtitle: "Serviço em destaque",
                  detail: "Notificação mais vista do período",
                },
              ]}
            />

            <WelcomeBeforeAfter />
            <WelcomeNotificationChart />
            <WelcomeBenefits />
            <WelcomeHowItWorks />
          </WelcomeSectionShell>
        </div>
      </div>
    </main>
  );
}
